import React from "react"

import {CustomRewardTransaction} from "@irati/types"
import {useIntl} from "@irati/utils/lang"
import StatusType from "@irati/wallet/types/enums/Status"
import authentication from "@irati/auth"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"

import SecondaryDetails from "../../SecondaryDetails/ViewMessage"
import {useBranding} from "@irati/brand"
import {StyledExpander} from "../../styled"
import PrimaryDetails from "../../PrimaryDetails"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"

interface Props {
  item: CustomRewardTransaction
  className?: string
}

const CustomRewardTransactionItem = (props: Props) => {
  const {item, className} = props
  const branding = useBranding()
  const {formatMessage} = useIntl()
  const sender = item.metadata?.createdBy
  const messages = {
    messageOne: "wallet.statementItem.adminReward.rewarded.received.primaryDetails.title.sender.one",
    messageReceiver: "wallet.statementItem.adminReward.rewarded.received.primaryDetails.title.receiver"
  }
  const status = item.receiver?.email === authentication.user().email ? StatusType.ADDED : StatusType.SENT
  const title = status === StatusType.ADDED ? messages.messageReceiver : messages.messageOne
  const userMessage = formatMessage(
    {id: title},
    {
      sender: firstnameLastname(sender),
      user: firstnameLastname(item.receiver)
    }
  )
  const primaryDetails = {
    image: branding?.businessLogoUrl || perkboxLogo,
    title: userMessage,
    subTitle: formatMessage({id: "platform.btn.viewDetails"}),
    amountTitle: item.customReward.title,
    status
  }
  const secondaryDetails = {
    userMessage,
    message: item.recognition.message
  }

  return (
    <StyledExpander
      className={className}
      PrimaryElement={() => <PrimaryDetails imgHeightAuto data={primaryDetails} />}
      SecondaryElement={<SecondaryDetails data={secondaryDetails} />}
    />
  )
}

export default CustomRewardTransactionItem
